<dialog #dialog aria-modal="true" class="popin-dialog">
    <div class="c-card c-card-small reduce-xs">
        <div class="c-card">
            <ng-container *ngIf="etapeConnexion === 1">
                <div class="modal-header pb-4">
                    <h1 class="custom titlePopin text-start" translate="connexion.cgu.titre"></h1>
                </div>

                <div class="c-text scroll-shadow-indicator">
                    <h2 class="c-text h4 shadow-none" translate="connexion.cgu.partie1"></h2>
                    <div class="c-text" [innerHTML]="'connexion.cgu.contenu1' | translate"></div>

                    <h2 class="c-text h4 mt-4" translate="connexion.cgu.partie2"></h2>
                    <div class="c-text" [innerHTML]="'connexion.cgu.contenu2' | translate"></div>

                    <h2 class="c-text h4 mt-4" translate="connexion.cgu.partie3"></h2>
                    <div class="c-text" [innerHTML]="'connexion.cgu.contenu3' | translate"></div>

                    <h2 class="c-text h4" translate="connexion.cgu.partie4"></h2>
                    <div class="c-text" [innerHTML]="'connexion.cgu.contenu4' | translate"></div>

                    <h2 class="c-text h4 mt-4" translate="connexion.cgu.partie5"></h2>
                    <div class="c-text" [innerHTML]="'connexion.cgu.contenu5' | translate"></div>

                    <h2 class="c-text h4 mt-4" translate="connexion.cgu.partie6"></h2>
                    <div class="c-text" [innerHTML]="'connexion.cgu.contenu6' | translate"></div>
                </div>

                <div class="card-footer px-0 mt-1 text-start">
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input"
                               (change)="accepterCgu()" id="cgu-ok" />
                        <label class="form-check-label mb-0" translate="connexion.cgu.accepter"
                               for="cgu-ok"></label>
                    </div>
                    <div class="my-2 c-text c-text-error" aria-live="polite">
                        <p *ngIf="cguNotSelected">
                            {{ 'connexion.cgu.erreur.pas-coche' | translate }}
                        </p>
                    </div>
                    <div class="text-center mt-4">
                        <button type="button" class="btn c-btn c-btn-ocean"
                                (click)="nextStep()" translate="global.form.button.next"></button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="etapeConnexion === 2">
                <form noValidate [formGroup]="form" *ngIf="form">
                    <div class="card-header pb-3">
                        <h1 class="custom titlePopin pb-1" translate="connexion.informations.titre"></h1>
                        <p class="text-muted smaller">
                            {{ 'global.form.disclaimer.required-and-optional' | translate }}
                        </p>
                    </div>

                    <div class="card-body pb-3">
                        <label class="h3 custom subTitlePage"
                               translate="global.form.email.label"></label>
                        <div class="input-group mb-2">
                            <input formControlName="adresseMail" class="form-control bg-light" autocomplete="email"
                                   placeholder="{{'connexion.informations.mail.placeholder' | translate }}" type="text"
                                   [attr.aria-invalid]="form.controls['adresseMail'].touched && (form.controls['adresseMail'].hasError('required') || form.controls['adresseMail'].hasError('pattern') || form.controls['adresseMail'].hasError('email'))">
                        </div>
                        <div class="my-2 c-text c-text-error"
                             *ngIf="form.controls['adresseMail'].errors"
                             id="email-messages" aria-live="polite">
                            <p *ngIf="form.controls['adresseMail'].touched && form.controls['adresseMail'].hasError('required')">
                                {{ 'global.form.error.required' | translate }}
                            </p>
                            <p *ngIf="form.controls['adresseMail'].touched && (form.controls['adresseMail'].hasError('pattern') || form.controls['adresseMail'].hasError('email'))">
                                {{ 'global.form.email.error.pattern' | translate }}
                            </p>
                        </div>

                        <label class="h3 custom subTitlePage mt-3">
                            {{ 'global.form.telephone.label' | translate }}
                            {{ 'global.form.label.optional' | translate }}
                        </label>
                        <div class="c-card-text c-text-grey mb-2"
                             translate="connexion.informations.telephone.info"></div>
                        <div class="input-group row-gap-4">
                            <ned-btn-indicatif-telephonique
                                [listeIndicatif]="listeIndicatifs"
                                [indexIndicatif]="indexIndicatif"
                                (choixIndicatifTelephonique)="choixPaysNumero($event.indicatif, $event.index)">
                            </ned-btn-indicatif-telephonique>
                            <div class="d-inline-flex">
                                <span *ngIf="indexIndicatif || indexIndicatif === 0" class="input-group-text">
                                    {{ listeIndicatifs[indexIndicatif].indicatifTelephonique }}
                                </span>
                                <input id="numero-tel-flag" formControlName="numeroTelephone" maxlength="255"
                                       type="tel" class="form-control bl-0" autocomplete="tel-national"
                                       aria-describedby="numero-tel-messages"
                                       placeholder="{{'connexion.informations.telephone.placeholder' | translate}}"
                                       [attr.aria-invalid]="form.controls['numeroTelephone'].touched && (form.controls['numeroTelephone'].hasError('erreurCaractere') || form.controls['numeroTelephone'].hasError('minlength') || form.controls['numeroTelephone'].hasError('maxlength'))"
                                >
                            </div>
                        </div>
                        <div class="mt-2 c-text c-text-error"
                             *ngIf="form.controls['numeroTelephone'].errors"
                             id="numero-tel-messages" aria-live="polite">
                            <p *ngIf="form.controls['numeroTelephone'].value && form.controls['numeroTelephone'].touched && form.controls['numeroTelephone'].hasError('erreurCaractere')">
                                {{ 'global.form.telephone.error.mauvais-caracteres' | translate }}
                            </p>
                            <p *ngIf="form.controls['numeroTelephone'].value && form.controls['numeroTelephone'].touched && (form.controls['numeroTelephone'].hasError('minlength') || form.controls['numeroTelephone'].hasError('maxlength'))">
                                {{ 'global.form.telephone.error.nombre-caracteres' | translate: { tailleNumeroPays: tailleNumeroPays } }}
                            </p>
                        </div>
                    </div>

                    <div class="card-footer">
                        <button type="button" class="btn c-btn c-btn-ocean"
                                (click)="nextStep()">
                            {{ 'global.form.button.next' | translate }}
                        </button>
                    </div>
                </form>
            </ng-container>

            <ng-container *ngIf="etapeConnexion === 3">
                <div class="card-header pb-3">
                    <h1 class="custom titlePopin text-break pb-3"
                        translate="connexion.tutoriel.titre"></h1>
                </div>

                <img src="/content/images/pictos/utils/picto-gp.svg" alt=""
                     class="img-video m-auto d-flex" height="200">
                <p class="c-card-text pt-3 pb-3"
                   [innerHTML]="'connexion.tutoriel.decouverte' | translate"></p>

                <div class="card-footer pt-3">
                    <div class="d-inline-flex flex-column flex-sm-row gap-2 justify-content-center">
                        <button class="btn btn-outline-info c-btn" type="button"
                                (click)="validerPremiereConnexion(false)"
                                translate="connexion.tutoriel.boutons.skip"></button>
                        <button class="btn c-btn c-btn-ocean" type="button"
                                (click)="validerPremiereConnexion(true)"
                                translate="connexion.tutoriel.boutons.access"></button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</dialog>
